// extracted by mini-css-extract-plugin
module.exports = {"stake":"amount__stake___2tO04","is-desktop":"amount__is-desktop___3tNIb","is-disabled":"amount__is-disabled___24KcS","is-active":"amount__is-active___2gcVR"};